var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 75,
    viewBox: "0 0 101 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56.0332,
    y: 1,
    width: 50,
    height: 53,
    rx: 2,
    transform: "rotate(28.1517 56.0332 1)",
    fill: "#D0CECE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57.6729,
    y: 6.41406,
    width: 42,
    height: 35.1962,
    transform: "rotate(28.1517 57.6729 6.41406)",
    fill: "#F7F7F7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.751,
    width: 50,
    height: 53,
    rx: 2,
    transform: "rotate(4.02927 26.751 0)",
    fill: "#D0CECE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.46,
    y: 4.27344,
    width: 42,
    height: 36.2598,
    transform: "rotate(4.02927 30.46 4.27344)",
    fill: "#F7F7F7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 28.4844,
    width: 50,
    height: 53,
    rx: 2,
    transform: "rotate(-30.709 0 28.4844)",
    fill: "#D0CECE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5.48145,
    y: 29.8828,
    width: 42,
    height: 34.6727,
    transform: "rotate(-30.709 5.48145 29.8828)",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/Files.5d940ad8d5ebb76751fd9d85f6d68569.svg";
export { ForwardRef as ReactComponent };